import { ProductBrand } from './StudioBrand';
import { ArrowRight, CircleHelp, HandHeart, MessageCircleQuestion, Stethoscope, Users } from 'lucide-react';
import { roleByKey } from '../lib/library';

const Section = ({ icon: Icon, title, children }) => !children ? null : (
  <section className="preview-card">
    <div className="preview-heading"><span className="icon-box"><Icon size={19}/></span><h3>{title}</h3></div>
    {children}
  </section>
);
const Bullets = ({ items }) => Array.isArray(items) && items.length ? <ul>{items.map((x,i)=><li key={i}>{x}</li>)}</ul> : null;

export default function PatientPreview({ role, onSelectRole }) {
  const c = role.content || {};
  const related = (c.similar_role_keys || c.similarRoleKeys || []).map(key => roleByKey.get(key)).filter(Boolean).slice(0, 6);
  const summary = c.summary;
  const whatTheyDo = c.what_they_do || c.whatTheyDo;
  const whenYouMightMeet = c.when_you_might_meet || c.whenYouMightMeet;
  const howTheyHelp = c.how_they_help || c.howTheyHelp;
  const askAbout = c.ask_about || c.askAbout;
  const additionalInfo = c.additional_info || c.additionalInfo;
  const moreInformation = c.more_information || c.moreInformation;
  return <div className="preview-column">
    <div className="phone-shell" aria-label={`Patient preview for ${role.title}`}>
      <div className="phone-bar"><ProductBrand /></div>
      <main className="patient-preview">
        <header className="preview-hero">
          <div className="hero-icon"><Stethoscope size={34}/></div>
          <p className="eyebrow">Meet your healthcare team</p>
          <h2>{role.title}</h2>
          <p className="summary">{summary || 'No patient summary has been drafted.'}</p>
        </header>
        <Section icon={Stethoscope} title="What they do"><Bullets items={whatTheyDo}/></Section>
        <Section icon={Users} title="When you might meet them"><Bullets items={whenYouMightMeet}/></Section>
        <Section icon={HandHeart} title="How they can help"><Bullets items={howTheyHelp}/></Section>
        <Section icon={MessageCircleQuestion} title="What you may wish to ask about"><Bullets items={askAbout}/></Section>
        {Array.isArray(c.faqs) && c.faqs.length > 0 && <Section icon={CircleHelp} title="Common questions">
          <div className="faq-list">{c.faqs.map((f,i)=><details key={i}><summary>{f.question}</summary><p>{f.answer}</p></details>)}</div>
        </Section>}
        {(additionalInfo || moreInformation) && <Section icon={CircleHelp} title="Good to know">{additionalInfo ? <p>{additionalInfo}</p> : <Bullets items={moreInformation}/>}</Section>}
        {related.length > 0 && <Section icon={Users} title="Related roles">
          <div className="related-grid">{related.map(item => <button key={item.roleKey} onClick={()=>onSelectRole(item.roleKey)}><span>{item.title}</span><ArrowRight size={16}/></button>)}</div>
        </Section>}
      </main>
    </div>
  </div>;
}
